// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"ffac3a69","442":"910c29fb","462":"54607334"}[chunkId] + ".chunk.js";
};